export function transformData(headerData,filterVal,data) {
  const list = [];
  let obj = {};
  for(let i = 0; i < data.length; i++) {
    obj = {};
    for(let x=0;x<headerData.length;x++){
      if(data[i][headerData[x]]!==undefined){
        obj[filterVal[x]]=data[i][headerData[x]]
      }else{
        obj[filterVal[x]]=null
      }
    }
    list.push(obj);
  }
  return list
}
export function nameToOrdinal(data,key,transformData) {
  if(transformData){
    for(let i=0;i<transformData.length;i++){
      if(transformData[i].name===data[key]){
        data[key]=transformData[i].ordinal
        break
      }
    }
  }
  return data
}
export function ordinalToName(data,key,transformData) {
  if(transformData){
    for(let i=0;i<transformData.length;i++){
      if(transformData[i].ordinal===data[key]){
        data[key]=transformData[i].name
        break
      }
    }
  }
  return data
}
export function nameToEntity(data,key,transformData) {
  if(transformData){
    for (let i=0;i<transformData.length;i++){
      if (transformData[i].name===data[key]){
        data[key]={id:transformData[i].id,name:transformData[i].name}
        break
      }
    }
  }
  if(!data[key]){
    data[key]=null
  }
  return data
}